module.exports = __webpack_public_path__ + "img/contract-50.29da2ff1.svg";